module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0132.jpg?v=4d12585a";